/* eslint-disable */
/*
  This file was auto-generated from config/recipes/templates/constants.js.erb
  DO NOT directly edit this file.
*/

export const CONFIG = {
  "registryAttributeDataOptions": {
    "clothingSizeOptions": [
      "9-12M",
      "12-18M",
      "18-24M",
      "2T",
      "3T",
      "4T",
      "5T",
      "6",
      "7",
      "8",
      "10",
      "12",
      "14",
      "16",
      "18",
      "20"
    ],
    "shoeSizeOptions": [
      {
        "group": "Baby & Walker",
        "size": "0"
      },
      {
        "group": "Baby & Walker",
        "size": "0.5"
      },
      {
        "group": "Baby & Walker",
        "size": "1"
      },
      {
        "group": "Baby & Walker",
        "size": "1.5"
      },
      {
        "group": "Baby & Walker",
        "size": "2"
      },
      {
        "group": "Baby & Walker",
        "size": "2.5"
      },
      {
        "group": "Baby & Walker",
        "size": "3"
      },
      {
        "group": "Baby & Walker",
        "size": "3.5"
      },
      {
        "group": "Baby & Walker",
        "size": "4"
      },
      {
        "group": "Baby & Walker",
        "size": "4.5"
      },
      {
        "group": "Baby & Walker",
        "size": "5"
      },
      {
        "group": "Baby & Walker",
        "size": "5.5"
      },
      {
        "group": "Baby & Walker",
        "size": "6"
      },
      {
        "group": "Baby & Walker",
        "size": "6.5"
      },
      {
        "group": "Baby & Walker",
        "size": "7"
      },
      {
        "group": "Toddler",
        "size": "7.5"
      },
      {
        "group": "Toddler",
        "size": "8"
      },
      {
        "group": "Toddler",
        "size": "8.5"
      },
      {
        "group": "Toddler",
        "size": "9"
      },
      {
        "group": "Toddler",
        "size": "10"
      },
      {
        "group": "Toddler",
        "size": "10.5"
      },
      {
        "group": "Toddler",
        "size": "11"
      },
      {
        "group": "Toddler",
        "size": "11.5"
      },
      {
        "group": "Toddler",
        "size": "12"
      },
      {
        "group": "Kids",
        "size": "12.5"
      },
      {
        "group": "Kids",
        "size": "13"
      },
      {
        "group": "Kids",
        "size": "13.5"
      },
      {
        "group": "Kids",
        "size": "1"
      },
      {
        "group": "Kids",
        "size": "1.5"
      },
      {
        "group": "Kids",
        "size": "2"
      },
      {
        "group": "Kids",
        "size": "2.5"
      },
      {
        "group": "Kids",
        "size": "3"
      },
      {
        "group": "Kids",
        "size": "3.5"
      },
      {
        "group": "Kids",
        "size": "4"
      },
      {
        "group": "Kids",
        "size": "4.5"
      },
      {
        "group": "Kids",
        "size": "5"
      },
      {
        "group": "Kids",
        "size": "5.5"
      },
      {
        "group": "Kids",
        "size": "6"
      },
      {
        "group": "Kids",
        "size": "6.5"
      },
      {
        "group": "Kids",
        "size": "7"
      }
    ],
    "favoriteColorOptions": [
      {
        "name": "red",
        "hex": "D82B20"
      },
      {
        "name": "orange",
        "hex": "F66707"
      },
      {
        "name": "green",
        "hex": "71CD5A"
      },
      {
        "name": "blue",
        "hex": "377DE7"
      },
      {
        "name": "purple",
        "hex": "66399F"
      },
      {
        "name": "brown",
        "hex": "B87D1C"
      },
      {
        "name": "pink",
        "hex": "FFB3AF"
      },
      {
        "name": "white",
        "hex": "FFFFFF"
      },
      {
        "name": "gray",
        "hex": "979797"
      },
      {
        "name": "black",
        "hex": "333333"
      },
      {
        "name": "yellow",
        "hex": "FFD951"
      },
      {
        "name": "rainbow",
        "hex": [
          "D82B20",
          "FFD951",
          "71CD5A",
          "377DE7"
        ]
      }
    ]
  },
  "cart": {
    "typeAmazonCart": "amazonCart",
    "typeRegistry": "registry",
    "typeStore": "store"
  },
  "registry": {
    "searchLevelOptions": {
      "babylist": "babylist",
      "private": "private",
      "public": "google"
    },
    "planningStageOptions": {
      "pregnant": "Pregnant",
      "adopting": "Adopting",
      "surrogate": "Working with a surrogate",
      "fostering": "Fostering",
      "conceiving": "Trying to conceive"
    },
    "expectingChildrenOptions": {
      "girl": "Girl",
      "boy": "Boy",
      "unknown": "Don't know yet",
      "notFindingOut": "Not finding out"
    },
    "showerGuestCountOptions": [
      "1-10",
      "11-20",
      "21-30",
      "31-40",
      "41-50",
      "50+"
    ],
    "showerGuestsTypeOptions": [
      "Family",
      "Friends",
      "Friends & Family",
      "Work Friends",
      "Other"
    ],
    "insertCardOrderQuantityOptions": [
      10,
      20,
      30,
      40,
      50,
      75,
      100
    ],
    "helloBabyBoxCreditAmount": 13,
    "helloBabyBoxShippingPrice": 8.95,
    "uneditableCategoryIds": [
      1
    ]
  },
  "store": {
    "registryDiscountFilter": "registry_discount",
    "registryDiscountExclusionsText": "The discount is one-time-use only and does not apply to gift cards, or shipping and handling fees, and cannot be used for the purchase of products from the following brands and products: Guava Family, Lovevery (subscription play kits), Million Dollar Baby (babyletto, Carter's by Davinci, Davinci, Namesake, Nursery Works, and Ubabub), Mockingbird, Nuna, Nurture&, Pampers, UPPAbaby, Diapers, and Wipes.\n\nThe registry discount cannot be combined with any other offer or applied to a previous purchase and is not redeemable for cash. Additional exclusions may apply.",
    "registryDiscountPct": 0.15,
    "registryDiscountPctDisplay": "15%",
    "productsPerPage": 18,
    "productCollections": {
      "popular": "popular_products"
    }
  }
}

// Top-level constants used by other constants
export const SUPPORT_EMAIL = 'support@babylist.com'

// Other constants
export const ACTIVE_NAV_SECTION_EVENT = 'activeNavSection'
export const AMZN_DEFAULT_CODE = 'blvisitor-20'
export const AMZN_REMOTE_CART_GG = 'bl-web-remote-cart-gg-20'
export const AMZN_SEARCH_CODE = 'blsearch-20'
export const ASYNC_CURRENT_USER_LOADED = 'asyncCurrentUser.loaded'
export const BABYLIST_EXTENSION_URL = 'https://chrome.google.com/webstore/detail/babylist/jcmljanephecacpljcpiogonhhadfpda'
export const CANONICAL_DISPLAY_HOST = 'babylist.com'
export const CANONICAL_URL = 'https://www.babylist.com'
export const CASH_FUND_PRODUCTS_CATEGORY_ID = 252
export const CASH_FUND_PRUDENTIAL_GENERIC_PRODUCT_ID = 14347
export const CATEGORY_ID_CASH_AND_GIFT = -13
export const CROWDFUND_PRODUCT_IDS = [338537, 338538, 338539, 338540, 338541, 338542, 338543, 338544]
export const COLLECTION_SLUG_TOPIC_NAVIGATION = 'topicNavigation'
export const COLLECTION_SLUG_HOME_TOPICS = 'hello-baby-home-topics'
export const CONTACT_US_URL = 'https://help.babylist.com/hc/en-us/requests/new'
export const COUNTRIES = ["Afghanistan","Åland Islands","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo","Congo, The Democratic Republic of the","Cook Islands","Costa Rica","Cote D'Ivoire","Croatia","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Falkland Islands (Malvinas)","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Heard Island and Mcdonald Islands","Holy See (Vatican City State)","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran, Islamic Republic Of","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea, Democratic People'S Republic of","Korea, Republic of","Kuwait","Kyrgyzstan","Lao People'S Democratic Republic","Latvia","Lebanon","Lesotho","Liberia","Libyan Arab Jamahiriya","Liechtenstein","Lithuania","Luxembourg","Macao","Macedonia, The Former Yugoslav Republic of","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia, Federated States of","Moldova, Republic of","Monaco","Mongolia","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","Palestinian Territory, Occupied","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russian Federation","RWANDA","Saint Helena","Saint Kitts and Nevis","Saint Lucia","Saint Pierre and Miquelon","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia and Montenegro","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and the South Sandwich Islands","Spain","Sri Lanka","Sudan","Suriname","Svalbard and Jan Mayen","Swaziland","Sweden","Switzerland","Syrian Arab Republic","Taiwan, Province of China","Tajikistan","Tanzania, United Republic of","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos Islands","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","United States Minor Outlying Islands","Uruguay","Uzbekistan","Vanuatu","Venezuela","Viet Nam","Virgin Islands, British","Virgin Islands, U.S.","Wallis and Futuna","Western Sahara","Yemen","Zambia","Zimbabwe"]
export const DEFAULT_FEED_ITEMS_PER_PAGE = 20
export const DEFAULT_PRODUCT_IMAGE_PATH = 'https://res.cloudinary.com/babylist/image/upload/c_scale,w_500/v1492642626/group-3_o4x4qq.png'
export const DEFAULT_REG_ITEM_IMAGE_PATH = 'https://images.babylist.com/image/upload/v1519149528/no-image_kbn727.png'
export const FB_CLIENT_TOKEN = '2fdf5733ddb9891a2bbbf92a13894b78'
export const FB_APP_ID = '109204149244707'
export const FLASH_MESSAGE = 'flashMessage'
export const FORM_KEY_NEW = '_new'
export const GENERIC_FAILURE_MESSAGE = `Oops! Something went wrong. Please contact <a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a> if the problem continues.`
export const GOOGLE_LOGIN_API_CLIENT_ID = '436969257099-pvaaemp1ro6r7edngp270b9idtmc7388.apps.googleusercontent.com'
export const GROUP_GIFT_GOAL_AMOUNT_BUFFER_PERCENT = '0.1'
export const GROUP_GIFT_GOAL_AMOUNT_BUFFER_PERCENT_DISPLAY = '10%'
export const HBB_QUALIFICATION_PURCHASE_AMOUNT = 30
export const HELLO_EMAIL = 'hello@babylist.com'
export const HIDE_APP_MODAL_EVENT = 'appModal.hide'
export const HIDE_MOBILE_NAV_MODAL_EVENT = 'mobileNavModal.hide'
export const HIDDEN_APP_MODAL_EVENT = 'appModal.hidden'
export const ELECTRONIC_GIFT_CARD_MAX = 1000
export const ELECTRONIC_GIFT_CARD_MIN = 25
export const EMAIL_USER_PREGNANCY = 'pregnancy'
export const EMAIL_USER_NEWSLETTER = 'newsletter'
export const EXTERNAL_REGISTRY_URL_EXCLUSION_REGEXES = [/amazon\.com\/?$/,/amazon\.com\/ap\/signin$/,/amazon\.com\/baby-reg\/checklist/,/amazon\.com\/baby-reg\/homepage/,/amazon\.com\/baby-reg\/huc\/?$/,/amazon\.com\/baby-reg\/manage\/?$/,/amazon\.com\/baby-reg\/mobile\/?$/,/amazon\.com\/baby-reg\/ref\/?$/,/amazon\.com\/baby-reg\/search\/?$/,/amazon\.com\/baby-reg\/share\?/,/amazon\.com\/baby-reg\/showWelcomeBox/,/amazon\.com\/baby-reg\/signup\/?$/,/amazon\.com\/baby-reg\/your\/?$/,/amazon\.com\/baby-reg\/your-registry\?/,/amazon\.com\/baby-reg\/?$/,/buybuybaby\.com\/?$/,/buybuybaby\.myregistry\.com\/?$/,/buybuybaby\.com\/store\/giftregistry\/registry-search-guest/,/babylist\.(com|test)\/?$/,/babylist\.(com|test)\/find/,/babylist\.(com|test)\/home/,/target\.com\/?$/,/target\.com\/gift-registry\/create-baby-registry/,/walmart\.com\/?$/,/walmart\.com\/registry\/baby\/(search|welcome)/]
export const FIREBASE_ANDROID_URL = 'https://babylist.page.link/49Sj'
export const FIREBASE_HOME_URL = 'https://babylist.page.link/rniX'
export const FIREBASE_IOS_URL = 'https://babylist.page.link/XQFV'
export const FIREBASE_MOBILE_WEB_ADD_ITEMS_PATH = 'WdJD'
export const FREE_SHIPPING_THRESHOLD = 45
export const KLARNA_TIER_HASH = '54b65d9d615d38f3cb3fbee6c73ba2b4ce72a6154be24153a2ccf819f1949112'
export const KLARNA_TIER_ID = 46674
export const PINTEREST_TAG_ID = '2620814336030'
export const PRODUCT_TYPE_EXTERNAL = 'external'
export const RECAPTCHA_SITE_KEY = '6LeklNcUAAAAAFn_ZU5-3VE-_Fz7FM-DmXBStNMU'
export const RECAPTCHA_V3_SITE_KEY = '6Lf_ytcUAAAAAD9_MZP1-c4DI895tYVYEJo2eSc-'
export const REGISTRY_LOAD_ALL_REG_ITEMS = 'registry.loadAllRegItems'
export const REGISTRY_PROFILE_IMG_TRANSFORM = 'w_340,h_340,c_thumb,f_auto'
export const ROUTE_CHANGE = 'routeChange'
export const RETURNS_AMAZON_URL = 'https://www.amazon.com/gp/help/customer/display.html?nodeId=201826610'
export const RETURNS_BUY_BUY_BABY_URL = 'https://www.buybuybaby.com/store/static/EasyReturns'
export const RETURNS_BUY_BUY_BABY_PHONE = '1-877-328-9222'
export const RETURNS_TARGET_URL = 'https://www.target.com/guest/returns'
export const RETURNS_TARGET_PHONE = '1-800-591-3869'
export const RETURNS_WALMART_URL = 'https://help.walmart.com/app/answers/detail/a_id/3228/kw/returns#R29'
export const RETURNS_WALMART_PHONE = '1-800-925-6278'
export const SALE_PREVIEW_CATEGORY_SLUGS = ["bfcm-preview-gear", "bfcm-preview-essentials"]
export const SHOW_APP_MODAL_EVENT = 'appModal.show'
export const SHOW_AUTH_MODAL_EVENT = 'authModal.show'
export const SHOW_CASH_FUND_WIZARD_MODAL = 'cashFundWizardModal.show'
export const SHOW_CASH_FUND_CONTRIBUTE_MODAL = 'cashFundContributeModal.show'
export const SHOW_CHECKLIST_AUTOCREATE_SAVE_REGISTRY_MODAL = 'checklistAutocreateSaveRegistryModal.show'
export const SHOW_MOBILE_NAV_EVENT = 'mobileNav.show'
export const SHOW_MOBILE_NAV_MODAL_EVENT = 'mobileNavModal.show'
export const SHOW_PRODUCT_ADDED_MODAL_EVENT = 'productAddedModal.show'
export const SHOW_GIFT_RETURN_MODAL = 'giftReturnModal.show'
export const SHOW_UNRESERVE_MODAL = 'unreserveModal.show'
export const SHOW_SEARCH_BAR = 'searchBar.show'
export const SOURCE_ADD_NEXT = 'add-next-recommendation'
export const SOURCE_BUTTON = 'button'
export const SOURCE_CATALOG = 'catalog'
export const SOURCE_CHECKLIST = 'checklist'
export const SOURCE_DISCOVER_QUICK_ADD = 'discover_quick_add'
export const SOURCE_FEED = 'feed'
export const SOURCE_POST_SIGNUP = 'onboarding_add_walkthrough'
export const STANDARD_SHIPPING_PRICE = 7.99
export const STATES_AND_PROVINCES = {"Canada":["AB","BC","MB","NB","NL","NS","NT","NU","ON","PE","QC","SK","YT"],"United States":["AL","AK","AZ","AR","CA","CO","CT","DE","DC","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY","AS","CZ","CM","FM","GU","MH","MP","PW","PI","PR","TT","VI","AA","AE","AP"]}
export const US_STATE_NAMES = {"AL":"Alabama","AK":"Alaska","AZ":"Arizona","AR":"Arkansas","CA":"California","CO":"Colorado","CT":"Connecticut","DC":"District of Columbia","DE":"Delaware","FL":"Florida","GA":"Georgia","HI":"Hawaii","ID":"Idaho","IL":"Illinois","IN":"Indiana","IA":"Iowa","KS":"Kansas","KY":"Kentucky","LA":"Louisiana","ME":"Maine","MD":"Maryland","MA":"Massachusetts","MI":"Michigan","MN":"Minnesota","MS":"Mississippi","MO":"Missouri","MT":"Montana","NE":"Nebraska","NV":"Nevada","NH":"New Hampshire","NJ":"New Jersey","NM":"New Mexico","NY":"New York","NC":"North Carolina","ND":"North Dakota","OH":"Ohio","OK":"Oklahoma","OR":"Oregon","PA":"Pennsylvania","RI":"Rhode Island","SC":"South Carolina","SD":"South Dakota","TN":"Tennessee","TX":"Texas","UT":"Utah","VT":"Vermont","VA":"Virginia","WA":"Washington","WV":"West Virginia","WI":"Wisconsin","WY":"Wyoming"}
export const STORE_NAVBAR_CATEGORY_SLUGS = ["strollers", "car-seats", "carriers", "nursery", "playroom", "bath-potty", "baby-health-safety", "feeding", "diapering", "clothing", "more"]
export const STORE_RETURNS_THRESHOLD = '9 months'
export const SYSTEM_ERROR_KEY = '_error'
export const SYSTEM_ERROR_MESSAGE = 'There was an error processing your request. Please contact customer service if this problem persists.'
export const UPDATE_CART_SUMMARY = 'cartSummary.update'
export const USER_SOURCE_EMAIL_NEWSLETTER_WIDGET = 'email:newsletter:widget'
export const USER_SOURCE_EMAIL_PREGNANCY_DIRECT = 'email:pregnancy:direct'
export const USER_SOURCE_EMAIL_PREGNANCY_WIDGET = 'email:pregnancy:widget'
export const USER_SOURCE_DIAPER_CALCULATOR = 'coregistration:diaper-calculator'
export const YAHOO_DOT_TAG_PIXEL_ID = '10070775'
export const YAHOO_DOT_TAG_PROJECT_ID = '10000'

export const AUTH_CONTEXT_REVIEW = 'AUTH_CONTEXT_REVIEW'
export const AUTH_CONTEXT_QUESTION = 'AUTH_CONTEXT_QUESTION'

// Experiments
export const EXPERIMENT_GROUPS = {"control":"control","experiment":"experiment"}

//Browser Names
export const CHROME = 'Chrome'
export const FIREFOX = 'Firefox'
export const IE = 'Internet Explorer'
export const MS_EDGE = 'Microsoft Edge'
export const SAFARI = 'Safari'

// Device platforms
export const DEVICE_PLATFORMS = {
  android: "android",
  desktop: "desktop",
  ios: "ios"
};

// Deferred payment thresholds
export const PAY_IN_4_MIN = 0.01
export const PAY_IN_4_MAX = 1999.99
export const FINANCING_MIN = 2000
export const FINANCING_MAX = 9999.99

// Warehouses
export const INGRAM_WAREHOUSES = [{"displayName":"Ingram - ONT1","externalId":46},{"displayName":"Ingram - EWR1","externalId":47},{"displayName":"Ingram - EWR2","externalId":59}]
export const DOTCOM_WAREHOUSE = {"displayName":"Dotcom","externalId":49}

// BL Health
export const MINIMUM_PATIENT_AGE = 10
export const MAXIMUM_PATIENT_AGE = 60

// UniversalNotificationModal PubSub Events
export const SET_UNIVERSAL_NOTIFICATION_MODAL_CONFIG_EVENT = 'setUniversalNotificationModalData'
export const SHOW_UNIVERSAL_NOTIFICATION_MODAL_EVENT = 'showUniversalNotificationModal'
export const HIDE_UNIVERSAL_NOTIFICATION_MODAL_EVENT = 'hideUniversalNotificationModal'
